import { render, staticRenderFns } from "./NoteList.vue?vue&type=template&id=0387ee30&scoped=true"
import script from "./NoteList.vue?vue&type=script&lang=ts"
export * from "./NoteList.vue?vue&type=script&lang=ts"
import style0 from "./NoteList.vue?vue&type=style&index=0&id=0387ee30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387ee30",
  null
  
)

export default component.exports